import * as React from "react";
import { cs } from "../../core/classSet";
import styles from "./Input.module.css";

export function InputHelpText({ errorText, helpText }: { helpText?: string; errorText?: string }) {
  if (errorText) {
    return <p className={styles.errorText}>{errorText}</p>;
  }
  if (helpText) {
    return <p className={styles.helpText}>{helpText}</p>;
  }
  return null;
}

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  append?: React.ReactNode;
  helpText?: string;
  errorText?: string;
  forwardedRef?: React.ForwardedRef<HTMLInputElement>;
  hasError?: boolean;
}

export default function Input({
  append,
  errorText,
  hasError,
  helpText,
  forwardedRef,
  ...inputProps
}: IProps) {
  return (
    <>
      <div className={styles.wrapper}>
        <input
          className={cs(styles.input, !!(errorText || hasError) && styles.inputError)}
          ref={forwardedRef}
          {...inputProps}
        />
        {append}
      </div>
      <InputHelpText errorText={errorText} helpText={helpText} />
    </>
  );
}
